<template>
  <div class="container">
    <!-- web-view 在 H5 平台会渲染为 iframe -->
<!--    <div :src="flutterPageUrl"></div>-->

    <!-- 或者你也可以直接使用 iframe 标签 -->
     <iframe :src="flutterPageUrl" frameborder="0" style="width: 100%; height: 100vh;"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 注意：在 H5 端，static 目录会被映射到网站根目录
      flutterPageUrl: '/flutter/index.html'
    }
  }
}
</script>

<style>
.container,
page {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

/* 确保 web-view 或 iframe 占满空间 */
web-view,
iframe {
  width: 100%;
  height: 100vh;
}
</style>